import React from "react";
import { Camera, Sparkles } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function IlLaboratorioMobile() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="il-laboratorio-mobile" className="dark bg-background text-foreground relative py-20 overflow-hidden" ref={ref}>
      {}
      <div className="absolute inset-0 pointer-events-none opacity-[0.03] bg-[url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0IiBoZWlnaHQ9IjQiPgo8cmVjdCB3aWR0aD0iNCIgaGVpZ2h0PSI0IiBmaWxsPSIjZmZmIi8+CjxyZWN0IHdpZHRoPSIxIiBoZWlnaHQ9IjEiIGZpbGw9IiMwMDAiLz4KPC9zdmc+')] mix-blend-overlay z-0" />

      <div className="container mx-auto px-4 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 lg:gap-10 items-start">
          
          {}
          <div className={`lg:col-span-7 flex flex-col h-full transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
            <div className="relative group h-full min-h-[500px] w-full overflow-hidden rounded-xl border border-white/10 bg-card/5 shadow-2xl">
              <div className="absolute inset-0 p-3">
                <div className="relative h-full w-full overflow-hidden rounded-lg border border-black/20 dark:border-white/5">
                  <img src="https://italianminuteros.com/wp-content/uploads/2026/03/Firefly_generami-un-immagine-con-protagonista-il-carretto-in-legno-della-foto-ma-in-un-contes-100614.png" alt="Bicicletta a tre ruote con laboratorio fotografico mobile" className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" />
                </div>
              </div>
            </div>
          </div>

          {}
          <div className="lg:col-span-5 flex flex-col gap-6 h-full">
            
            {}
            <div className={`transition-all duration-1000 delay-200 ease-out ${isVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-12"}`}>
              <div className="relative group aspect-video w-full overflow-hidden rounded-xl border border-white/10 bg-card/5 shadow-xl">
                <div className="absolute inset-0 p-3">
                  <div className="relative h-full w-full overflow-hidden rounded-lg border border-black/20 dark:border-white/5">
                    <img src="https://italianminuteros.com/wp-content/uploads/2026/03/okk.jpg" alt="Dettaglio macro lente in ottone vintage" className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" />
                  </div>
                </div>
              </div>
            </div>

            {}
            <Card className={`bg-card/10 border-white/10 backdrop-blur-sm transition-all duration-1000 delay-400 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
              <CardHeader className="pb-2">
                <div className="flex items-center justify-between mb-2">
                  <Badge variant="outline" className="border-primary/50 text-primary bg-primary/10 px-3 py-1 text-xs uppercase tracking-widest">Book an Experience</Badge>
                  <Sparkles className="w-4 h-4 text-primary/60" />
                </div>
                <CardTitle className="text-2xl md:text-3xl font-serif tracking-tight text-white">
                  The Traveling Laboratory
                </CardTitle>
              </CardHeader>
              <CardContent className="space-y-6">
                <CardDescription className="text-base text-muted-foreground leading-relaxed">Our photographic carts and three-wheeled bicycles are not simple props, but real working laboratories. Handcrafted and carefully reconstructed, they bring the magic of analog photography directly to the street.</CardDescription>
                
                <div className="space-y-4">
                  <div className="flex items-start gap-3">
                    <div className="mt-1 p-1.5 rounded-full bg-primary/10 text-primary">
                      <Camera className="w-4 h-4" />
                    </div>
                    <div>
                      <h4 className="text-sm font-medium text-white">Instant Development</h4>
                      <p className="text-sm text-muted-foreground">An authentic chemical process, performed right before your eyes..</p>
                    </div>
                  </div>
                </div>

                <div className="pt-2">
                  <Button asChild variant="default" className="w-full sm:w-auto bg-primary text-primary-foreground hover:bg-primary/90">
                    <Link to="/ContactPage">Book for your event</Link>
                  </Button>
                </div>
              </CardContent>
            </Card>

          </div>
        </div>
      </div>
    </section>;
}